// extracted by mini-css-extract-plugin
export default {"tooltip":"eW-z","arrow":"fW-z"};